const vaseList = [
    {
        id: 0,
        title: "Acanthus, 2020",
        image: require("./assets/vase-5.webp"),
        className: " absolute -my-44 mx-[94px] md:mx-[110px] opacity-0 group-hover:opacity-100",
        measurement: "33cm x 32cm",
        description: 'terracotta, lead glaze'

    },
    {
        id: 1,
        title: "Shredded Vases, 2023",
        image: require("./assets/vase-1.webp"),
        className: "absolute -my-44 mx-[94px] md:mx-[110px] opacity-0 group-hover:opacity-100",
        measurement: "24cm x 30cm, 30cm x 24cm",
        description: 'white clay, copper oxide, black glaze, coffee glaze'

    },
    {
        id: 2,
        title: "Pot Pourri, 2019",
        image: require("./assets/vase-4.webp"),
        className: " absolute -my-44 mx-[96px] md:mx-[110px] opacity-0 group-hover:opacity-100",
        measurement: "12.3cm x 23.6cm",
        description: 'terracotta, white slip, black iron oxide'

    },
    {
        id: 3,
        title: "Winter Afternoon, 2021",
        image: require("./assets/vase-2.webp"),
        className: " absolute -my-44 mx-[52px] md:mx-[60px] opacity-0 group-hover:opacity-100",
        measurement: "228/35cm x 23/25cm",
        description: 'white clay, red iron oxide, copper oxide, clear glaze'

    },
    {
        id: 4,
        title: "Sea Vase And Its Rock, 2022",
        image: require("./assets/vase-6.webp"),
        className: "absolute -my-44 mx-24 md:mx-28 opacity-0 group-hover:opacity-100",
        measurement: "16cm x 32 cm",
        description: 'anthracite stoneware, iron oxides, white clay'
        

    },
    {
        id: 5,
        title: "Three Sea Vases, 2022",
        image: require("./assets/vase-3.webp"),
        className: "absolute -my-44 mx-24 md:mx-28 opacity-0 group-hover:opacity-100",
        measurement: "21cm x 20/23cm",
        description: 'gray stoneware, iron oxides, tin glaze'
        

    },
     

]

export default vaseList;